export default __webpack_public_path__ + "static/media/central_andes_2_17.1ed34d79.JPG";